import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { FooterMenuComponent } from './footer-menu/footer-menu.component';
import { ConstructionComponent } from './construction/construction.component';
import { BridgeConditionsComponent } from './bridge-conditions/bridge-conditions.component';
import { TIPComponent } from './tip/tip.component';
import { ConstructionMapComponent } from './construction-map/construction-map.component';
import { TIPMapComponent } from './tip-vis-map/tip-vis-map.component';
import { BridgeConditionsMapComponent } from './bridge-conditions-map/bridge-conditions-map.component';
import { AOIComponent } from './aoi/aoi.component';
import { ReportLauncher } from './reports/report-launcher';
import { SummaryReportComponent } from './summary-report/summary-report.component';
import { BridgeConditionsReportComponent } from './bridge-conditions-report/bridge-conditions-report.component';
import { ProjectReportComponent } from './project-report/project-report.component';
import { FundingCategoryLookupComponent } from './funding-category-lookup/funding-category-lookup.component';
import { MobileHomeComponent } from './mobile-home/mobile-home.component';

const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
  { path: 'construction', component: ConstructionComponent, pathMatch: 'full' },
  { path: 'tip', component: TIPComponent, pathMatch: 'full' },
  { path: 'bridge-conditions', component: BridgeConditionsComponent, pathMatch: 'full' },
  { path: 'construction-map', component: ConstructionMapComponent, pathMatch: 'full' },
  { path: 'tip-vis-map', component: TIPMapComponent, pathMatch: 'full' },
  { path: 'bridge-conditions-map', component: BridgeConditionsMapComponent, pathMatch: 'full' },
  { path: 'bridge-conditions-report', component: BridgeConditionsReportComponent, pathMatch: 'full' },
  { path: 'summary-report', component: SummaryReportComponent, pathMatch: 'full' },
  { path: 'project-report', component: ProjectReportComponent, pathMatch: 'full' },
  { path: 'funding-category-lookup', component: FundingCategoryLookupComponent, pathMatch: 'full' },
  { path: 'mobile-home', component: MobileHomeComponent, pathMatch: 'full'}
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    NavMenuComponent,
    FooterMenuComponent,
    ConstructionComponent,
    TIPComponent,
    BridgeConditionsComponent,
    ConstructionMapComponent,
    TIPMapComponent,
    BridgeConditionsMapComponent,
    AOIComponent,
    SummaryReportComponent,
    BridgeConditionsReportComponent,
    ProjectReportComponent,
    FundingCategoryLookupComponent,
    MobileHomeComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot(routes)
  ],
  exports: [
    [RouterModule]
  ],
  providers: [ReportLauncher],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})
export class AppModule { }
